import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38401098"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "article" }
const _hoisted_2 = { class: "article-img" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "article-text" }
const _hoisted_5 = { class: "article-author" }
const _hoisted_6 = { class: "article-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "article-img-photo",
        src: _ctx.article.address,
        alt: _ctx.article.alt
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, "By " + _toDisplayString(_ctx.article.author), 1),
      _createElementVNode("h3", null, _toDisplayString(_ctx.article.title), 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.article.description), 1)
    ])
  ]))
}